export const ClientError = {
    REQUIRE_TOTP: 122,
};